<p-dialog
  header="{{ dialogContent.title | translate }}"
  [(visible)]="showDialog"
  [style]="{ width: '90vw', height: '80vh' }"
  [modal]="true"
  styleClass="{{ dialogContent.styleClass }}"
  [draggable]="false"
  (onHide)="onClose()"
>
  <div class="w-full flex flex-1 h-full overflow-hidden">
    <div
      class="w-1/6 h-full bg-[--pho_white_shade1]"
      *ngIf="enableExpSelection"
    >
      <p-tabView
        styleClass="move-tab-view"
        *ngIf="dialogContent?.tabDetails.length"
      >
        <ng-container *ngFor="let tab of dialogContent?.tabDetails">
          <p-tabPanel header="{{ tab.heading | translate }}">
            <ng-template pTemplate="header">
              <span (click)="dialogTabChange(tab.key)">{{ tab.heading | translate }}</span>
            </ng-template>
          </p-tabPanel>
        </ng-container>
      </p-tabView>
    </div>

    <div class="w-5/6 h-full">
      <div class="w-full h-full">
        <div class="flex w-full items-center justify-between mb-3 p-3.5 pb-0">
          <div class="breadcrumbs-folder">
            <ul class="flex items-center">
              <li
                *ngFor="
                  let breadcrumb of breadcrumbTrailMap[currentTab];
                  let i = index;
                  let last = last
                "
                class="cursor-pointer text-sm"
                [class.text-gray-400]="last"
                (click)="!last ? onNavigateBack(breadcrumb) : ''"
              >
                <span>
                  {{ breadcrumb.label | translate }}
                </span>
                <span *ngIf="!last" class="mx-1">/</span>
              </li>
            </ul>
          </div>

          <div class="flex justify-between items-center gap-2">
            <app-svg-icon
              class="cursor-pointer"
              [icon]="
                showTableFilters ? 'icon-filter-grey-clear' : 'icon-filter-grey'
              "
              padding="10px"
              [color]="showTableFilters ? '#d14447' : '#858585'"
              (click)="filterCallback($event)"
            >
            </app-svg-icon>
            <div
              *ngIf="!enableExpSelection"
              class="font-semibold text-[#E5B611] text-sm cursor-pointer"
              (click)="enableExperimentSelection()"
            >
              + {{ "BULK_EXPORT.ADD_EXPERIMENT" | translate }}
            </div>
            <app-group-by-dropdown
              *ngIf="currentTab === 'published'"
              [selectedGroupBy]="selectedGroupByOption"
              [panelClassName]="'ml-[-75px]'"
              (groupByChange)="handleGroupByChange($event)"
            ></app-group-by-dropdown>
          </div>
        </div>

        <div class="move-experiment-table">
          <ng-container
            *ngIf="
              currentTab === 'published' &&
                groupedPublishedData?.groups?.length;
              else flatExperimentList
            "
          >
            <app-row-group-experiment-list
              [groupsData]="groupedPublishedData"
              [tableColumns]="dialogContent.tableColumns"
              [showFilters]="showTableFilters"
              [enableCreatedByColumn]="isCurrentTabPublished"
              [accordionTemplate]="plansAccordion"
              (emitTableAction)="getTableAction($event)"
              (groupExpand)="onGroupedRowExpand($event)"
            ></app-row-group-experiment-list>
          </ng-container>

          <ng-template #flatExperimentList>
            <app-experiment-list
              [tableColumns]="dialogContent.tableColumns"
              [tableData]="experimentList[currentTab]"
              [allData]="experimentList[currentTab]"
              [skeletonLoader]="true"
              [dragDropDisabled]="true"
              [pageSize]="pageSize"
              [showFilters]="showTableFilters"
              [currentPage]="currentPage"
              [totalPages]="totalPages"
              [totalItems]="
                fetchOnDemand
                  ? totalRecords
                  : experimentList[currentTab].length || 0
              "
              [moveDialogView]="true"
              [isClientSide]="fetchOnDemand ? false : true"
              [showAccordion]="showAccordion"
              [hideFolderCheckbox]="hideFolderCheckbox"
              [useSelectionService]="isUseSelectionService"
              [preserveCheckedRows]="
                !!activeSelectedExperimentIds || !hideFolderCheckbox
              "
              (rowCheckboxChange)="experimentRowCheckboxChange($event)"
              (emitTableAction)="getTableAction($event)"
              [accordionTemplate]="plansAccordion"
              [enableCreatedByColumn]="isCurrentTabPublished"
            ></app-experiment-list>
          </ng-template>
        </div>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="flex justify-end gap-3">
      <app-button-secondary
        [buttonCaption]="'SHARED.CANCEL' | translate"
        buttonClassName="xs-medium"
        (actionButtonCall)="onClose(false)"
      ></app-button-secondary>
      <app-button-primary
        [buttonCaption]="'SHARED.PROCEED' | translate"
        buttonClassName="xs-medium"
        [buttonDisabled]="isSelectionInvalid"
        (actionButtonCall)="addExperiments(true)"
      ></app-button-primary>
    </div>
  </ng-template>
</p-dialog>

<!-- Plans Accordion for Bulk Actions -->
<ng-template #plansAccordion let-data>
  <table class="nested-table">
    <thead>
      <tr>
        <th *ngIf="enableExpSelection"></th>
        <th>{{ "GRID.PLAN_NAME" | translate }}</th>
        <th>{{ "GRID.NO_OF_SKUS" | translate }}</th>
        <th>{{ "GRID.DOORS" | translate }}</th>
        <th>{{ "GRID.SHELVES" | translate }}</th>
        <th>
          {{ "GRID.WIDTH" | translate }} x {{ "GRID.HEIGHT" | translate }} x
          {{ "GRID.DEPTH" | translate }}
        </th>
        <th>{{ "GRID.CREATED_BY" | translate }}</th>
        <th>{{ "GRID.CREATED_AT" | translate }}</th>
        <th>{{ "GRID.STATUS" | translate }}</th>
      </tr>
    </thead>
    <tbody>
      <ng-container
        *ngIf="
          plansMapforExperiment[data.id] &&
            plansMapforExperiment[data.id]!.length > 0;
          else noPlanData
        "
      >
        <tr *ngFor="let plan of plansMapforExperiment[data.id]">
          <td *ngIf="enableExpSelection">
            <div
              *ngIf="radioSelection; else checkboxSelectionTemplate"
              class="mr-2"
            >
              <p-radioButton
                [inputId]="'radio-' + plan?.id"
                name="planSelectionGroup"
                [(ngModel)]="selectedPlanId"
                [value]="{ planId: plan?.id, expId: data?.id }"
                styleClass="radio-button-selection"
              ></p-radioButton>
            </div>
            <ng-template #checkboxSelectionTemplate>
              <p-checkbox
                [binary]="true"
                [inputId]="'checkbox-' + data.id"
                [ngModel]="plan.isChecked"
                (onChange)="toggleRowSelection($event, data, plan)"
                *ngIf="!isSinglePlanSelect"
              ></p-checkbox>
              <p-radioButton
                styleClass="plan-radio"
                name="plan-selection"
                [value]="plan"
                [(ngModel)]="selectedSinglePlan"
                (onClick)="toggleRadioSelection($event, data, plan)"
                *ngIf="isSinglePlanSelect"
              ></p-radioButton>
            </ng-template>
          </td>
          <td>{{ plan?.name }}</td>
          <td>{{ plan?.sku_count ?? "-" }}</td>
          <td>{{ plan?.grid?.doors ?? "-" }}</td>
          <td>{{ plan?.grid?.shelves ?? "-" }}</td>
          <td>
            <ng-container
              *ngIf="
                plan?.grid?.width && plan?.grid?.height && plan?.grid?.depth;
                else noGridData
              "
            >
              {{ plan?.grid?.width }} x {{ plan?.grid?.height }} x
              {{ plan?.grid?.depth }}
            </ng-container>
            <ng-template #noGridData>-</ng-template>
          </td>
          <td>
            {{ plan?.owner_by?.first_name }}
            {{ plan?.owner_by?.last_name }}
          </td>
          <td>{{ formatHumanReadableDate(plan?.created_at) }}</td>
          <td class="{{ plan?.status }}">{{ plan?.status | titleCase }}</td>
        </tr>
      </ng-container>

      <ng-template #noPlanData>
        <tr>
          <td class="rounded-lg text-center px-2 py-3" colspan="9">
            {{ "PHO.NO_RECORDS_FOUND" | translate }}
          </td>
        </tr>
      </ng-template>
    </tbody>
  </table>
</ng-template>
